import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

interface AppData {
  app_id: number;
  app_name: string;
  description: string;
  app_type: string;
  status: string;
  app_json: any;
  workspace_id: number;
  creator_user_id: number;
  create_time: string;
  update_time: string;
}

const Debug: React.FC = () => {
  const { appId } = useParams<{ appId: string }>();
  const [appData, setAppData] = useState<AppData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAppData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get<AppData>(`https://ceshi.lightark.cc/api/v1/apps/${appId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setAppData(response.data);
      } catch (err) {
        setError('获取应用数据失败');
        console.error('Error fetching app data:', err);
      } finally {
        setLoading(false);
      }
    };

    if (appId) {
      fetchAppData();
    }
  }, [appId]);

  if (loading) {
    return <div className="debug-container">加载中...</div>;
  }

  if (error) {
    return <div className="debug-container">{error}</div>;
  }

  return (
    <div className="debug-container">
      <h1>应用调试信息</h1>
      <div className="debug-content">
        <div className="debug-section">
          <h2>基本信息</h2>
          <p><strong>应用ID:</strong> {appData?.app_id || '-'}</p>
          <p><strong>应用名称:</strong> {appData?.app_name || '-'}</p>
          <p><strong>描述:</strong> {appData?.description || '-'}</p>
          <p><strong>类型:</strong> {appData?.app_type || '-'}</p>
          <p><strong>状态:</strong> {appData?.status || '-'}</p>
        </div>
        
        <div className="debug-section">
          <h2>配置信息</h2>
          <pre>{JSON.stringify(appData?.app_json || {}, null, 2)}</pre>
        </div>
        
        <div className="debug-section">
          <h2>其他信息</h2>
          <p><strong>工作空间ID:</strong> {appData?.workspace_id || '-'}</p>
          <p><strong>创建者ID:</strong> {appData?.creator_user_id || '-'}</p>
          <p><strong>创建时间:</strong> {appData?.create_time || '-'}</p>
          <p><strong>更新时间:</strong> {appData?.update_time || '-'}</p>
        </div>
      </div>
    </div>
  );
};

export default Debug; 